import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Send, MessageSquare, Home, Users, Calendar } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const MobileBottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();
  
  // Navigation items based on mockups - 5 icons
  const navItems = [
    { to: '/messagerie', icon: Send, label: 'Messages' },
    { to: '/incidents', icon: MessageSquare, label: 'Incidents' },
    { to: '/', icon: Home, label: 'Accueil' },
    { to: '/coproprietaires', icon: Users, label: 'Contacts', roles: ['gestionnaire', 'admin'] },
    { to: '/assemblees', icon: Calendar, label: 'AG' },
  ];

  // Filter items based on user role
  const filteredItems = navItems.filter(item => {
    if (!item.roles) return true;
    return item.roles.includes(user?.role);
  });

  // For prestataire, replace contacts with a placeholder
  const displayItems = user?.role === 'prestataire' 
    ? [
        { to: '/messagerie', icon: Send, label: 'Messages' },
        { to: '/incidents', icon: MessageSquare, label: 'Incidents' },
        { to: '/', icon: Home, label: 'Accueil' },
      ]
    : filteredItems;

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40 lg:hidden"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {displayItems.map((item) => {
          const isActive = location.pathname === item.to || 
            (item.to === '/' && location.pathname === '/');
          const Icon = item.icon;
          
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className="flex flex-col items-center justify-center flex-1 py-2 group"
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <div className={`p-1.5 rounded-full transition-all ${
                isActive 
                  ? 'bg-[#00D3A8]/10' 
                  : 'group-hover:bg-gray-100'
              }`}>
                <Icon 
                  size={22} 
                  strokeWidth={isActive ? 2 : 1.5}
                  className={`transition-colors ${
                    isActive 
                      ? 'text-[#00D3A8]' 
                      : 'text-gray-500 group-hover:text-gray-700'
                  }`}
                />
              </div>
              <span className={`text-[10px] mt-0.5 transition-colors ${
                isActive 
                  ? 'text-[#00D3A8] font-medium' 
                  : 'text-gray-500'
              }`}>
                {item.label}
              </span>
              {/* Active indicator dot */}
              {isActive && (
                <div className="w-1 h-1 rounded-full bg-[#00D3A8] mt-0.5" />
              )}
            </NavLink>
          );
        })}
      </div>
      {/* Safe area for devices with home indicator */}
      <div className="h-safe-area-inset-bottom bg-white" />
    </nav>
  );
};

export default MobileBottomNav;
